import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "app" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_Topbar = _resolveComponent("Topbar")!
  const _component_Navbar = _resolveComponent("Navbar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Footer = _resolveComponent("Footer")!
  const _component_BackToTop = _resolveComponent("BackToTop")!
  const _component_VideoModal = _resolveComponent("VideoModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Spinner),
    _createVNode(_component_Topbar),
    _createVNode(_component_Navbar),
    _createVNode(_component_router_view),
    _createVNode(_component_Footer),
    _createVNode(_component_BackToTop),
    _createVNode(_component_VideoModal)
  ]))
}